import { isObject } from '../utils/isObject.js';

const mergeCapabilityPatch = ({ currentValue, patchValue } = {}) => {
  const currentObject = isObject(currentValue) ? currentValue : {};
  const patchObject = isObject(patchValue) ? patchValue : {};
  const allKeys = new Set([...Object.keys(currentObject), ...Object.keys(patchObject)]);
  const nextValue = {};

  for (const key of allKeys) {
    const currentEntry = currentObject[key];
    const patchEntry = patchObject[key];

    if (patchEntry === null) {
      continue;
    }

    if (isObject(currentEntry) && isObject(patchEntry)) {
      nextValue[key] = mergeCapabilityPatch({
        currentValue: currentEntry,
        patchValue: patchEntry
      });
      continue;
    }

    nextValue[key] = patchEntry !== undefined ? patchEntry : currentEntry;
  }

  return nextValue;
};

export default mergeCapabilityPatch;
